import React from 'react';
import '../styles/Pagination.css'


function Pagination({ currentPage, totalPages, onPageChange }) {

    // Функция для генерации видимых страниц
    const getVisiblePages = () => {
        if (totalPages <= 1) return [];

        // Всегда показываем первую и последнюю страницы
        const alwaysShowPages = [1, totalPages];

        // Добавляем страницы вокруг текущей
        let startPage = Math.max(2, currentPage - 1);
        let endPage = Math.min(totalPages - 1, currentPage + 1);

        // Собираем все страницы, которые нужно показать, Set используется для автоматического удаления дубликатов, Array.from заполняет массив числами от startPage до endPage
        const allPagesToShow = new Set([
            ...alwaysShowPages,
            ...Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i)
        ]);

        // Сортируем числа по возрастанию и преобразуем в массив
        return Array.from(allPagesToShow).sort((a, b) => a - b);
    };

    return (
        <div className="pagination">
            <button
                onClick={() => onPageChange(1)}
                disabled={currentPage === 1}
                className="pagination-button"
            >
                &laquo;
            </button>

            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="pagination-button"
            >
                &lsaquo;
            </button>

            {(() => {
                // Вызываем функцию, которая возвращает массив номеров страниц для отображения
                const visiblePages = getVisiblePages();
                // Создаём пустой массив, куда будем складывать элементы
                const result = [];

                for (let i = 0; i < visiblePages.length; i++) {
                    // Добавляем кнопку текущей страницы в массив результатов
                    result.push(
                        <button
                            key={visiblePages[i]}
                            onClick={() => onPageChange(visiblePages[i])}
                            className={`pagination-button ${currentPage === visiblePages[i] ? 'active-number' : ''}`}
                        >
                            {visiblePages[i]}
                        </button>
                    );

                    // Добавляем многоточие, если между текущей и следующей страницей есть разрыв
                    // Условие срабатывает если:
                    // 1. Это не последний элемент
                    // 2. Следующая страница не является соседней по номеру (разница > 1)
                    if (i < visiblePages.length - 1 && visiblePages[i + 1] - visiblePages[i] > 1) {
                        result.push(
                            <span key={`ellipsis-${visiblePages[i]}`} className="pagination-ellipsis">
                                ...
                            </span>
                        );
                    }
                }

                return result;
            })()}

            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="pagination-button"
            >
                &rsaquo;
            </button>

            <button
                onClick={() => onPageChange(totalPages)}
                disabled={currentPage === totalPages}
                className="pagination-button"
            >
                &raquo;
            </button>
        </div>
    )
}

export default Pagination;